import { useEffect, useState } from 'react'
import { Space, Select } from 'antd'
import { baseAxiosComplete } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'

const { Option } = Select

export default function UserInfo() {

    const [userData, setUserData] = useState<any>({ user_name: '', phone: '', position_list: [] })

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        setUserData(JSON.parse(data))
    }, [])

    return (<div className="common-page">
        {/* 首页 -> 首页 -> 个人信息 */}
        <BreadCrumb position={['首页', '个人信息']} />

        <div className="common-main">
            <div>
                <Space>
                    姓名：{userData.user_name}
                </Space>
            </div>

            <div>
                <Space >
                    <p style={{ marginTop: '20px' }}>职位切换：</p>

                    <Select style={{ width: 140 }} onChange={(v: string) => {
                        baseAxiosComplete.post('/global/change_position', {
                            position_id: v

                        }).then((res: any) => {
                            if (res.status === 0) {
                                let data: any = localStorage.getItem('userData')
                                data = JSON.parse(data)

                                data.top_menu_list = res.data.top_menu_list
                                data.left_menu_list = res.data.left_menu_list
                                data.right_menu_list = res.data.right_menu_list

                                localStorage.setItem('userData', JSON.stringify(data))
                                window.location.pathname = ''
                            }
                        })
                    }}>
                        {userData.position_list.map((el: { position_id: string, position_name: string }) => <Option key={el.position_id} value={el.position_id}>{el.position_name}</Option>)}
                    </Select>
                </Space>
            </div>
        </div>
    </div>)
}